"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _sale = require("./sale.store");
var _sale2 = require("../utils/sale.utils");
var _pointsExchangeWalletBalance = _interopRequireDefault(require("./points-exchange-wallet-balance.store"));
var _class;
const POINTS_EXCHANGE_TYPE = 'points-exchange';
/**
 * Promo page store
 */
let PointsExchangeConfirmationPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} $env
   * @param {Object} initialState
   */
  function PointsExchangeConfirmationPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, PointsExchangeConfirmationPageStore);
    this.$env = void 0;
    this.saleStore = void 0;
    this.walletBalanceStore = void 0;
    this.$env = $env;
    this.updateInitialState(initialState);
    this.saleStore = new _sale.MyAccountSaleStore(initialState.saleStore, $env, null, null);
    this.walletBalanceStore = new _pointsExchangeWalletBalance.default(initialState.walletBalanceStore);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(PointsExchangeConfirmationPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "transactionId",
    get: function () {
      var _this$booking;
      return (_this$booking = this.booking) === null || _this$booking === void 0 ? void 0 : _this$booking.orderNumber;
    }
  }, {
    key: "redeem",
    get: function () {
      var _this$saleStore$data, _this$saleStore$data$;
      return (_this$saleStore$data = this.saleStore.data) === null || _this$saleStore$data === void 0 ? void 0 : (_this$saleStore$data$ = _this$saleStore$data.loyalty) === null || _this$saleStore$data$ === void 0 ? void 0 : _this$saleStore$data$.redeem;
    }
  }, {
    key: "reward",
    get: function () {
      return (0, _sale2.getSaleReward)(this.saleStore);
    }
  }, {
    key: "isInward",
    get: function () {
      var _this$conversionData, _this$conversionData$;
      return ((_this$conversionData = this.conversionData) === null || _this$conversionData === void 0 ? void 0 : (_this$conversionData$ = _this$conversionData.conversionConfig) === null || _this$conversionData$ === void 0 ? void 0 : _this$conversionData$.target) === 'wallet';
    }
  }, {
    key: "loyalty",
    get: function () {
      return this.isInward ? this.redeem : this.reward;
    }
  }, {
    key: "walletBalance",
    get: function () {
      var _this$walletBalanceSt, _this$walletBalanceSt2;
      return (_this$walletBalanceSt = this.walletBalanceStore) === null || _this$walletBalanceSt === void 0 ? void 0 : (_this$walletBalanceSt2 = _this$walletBalanceSt.availableBalance) === null || _this$walletBalanceSt2 === void 0 ? void 0 : _this$walletBalanceSt2.amount;
    }
  }, {
    key: "booking",
    get: function () {
      var _this$saleStore$booki;
      return (_this$saleStore$booki = this.saleStore.bookings) === null || _this$saleStore$booki === void 0 ? void 0 : _this$saleStore$booki.filter(booking => booking.type === POINTS_EXCHANGE_TYPE)[0];
    }
  }, {
    key: "product",
    get: function () {
      var _this$booking2;
      return (_this$booking2 = this.booking) === null || _this$booking2 === void 0 ? void 0 : _this$booking2.products.filter(product => product.type === POINTS_EXCHANGE_TYPE)[0];
    }
  }, {
    key: "conversionData",
    get: function () {
      var _this$product;
      return (_this$product = this.product) === null || _this$product === void 0 ? void 0 : _this$product.options.conversionData;
    }
  }, {
    key: "userEmail",
    get: function () {
      var _this$booking3, _this$booking3$contac, _this$booking4;
      return ((_this$booking3 = this.booking) === null || _this$booking3 === void 0 ? void 0 : (_this$booking3$contac = _this$booking3.contact) === null || _this$booking3$contac === void 0 ? void 0 : _this$booking3$contac.email) || ((_this$booking4 = this.booking) === null || _this$booking4 === void 0 ? void 0 : _this$booking4.customerEmail);
    }
  }]);
  return PointsExchangeConfirmationPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "transactionId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "transactionId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "redeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isInward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "loyalty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loyalty"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "walletBalance", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "walletBalance"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "booking", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "booking"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "product", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "conversionData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conversionData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "userEmail", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userEmail"), _class.prototype)), _class);
exports.default = PointsExchangeConfirmationPageStore;